var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredentialItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2317 7.29474C20.1159 8.17895 20.1159 9.61579 19.2317 10.5L16.0265 13.7053L7.18435 4.86316L10.3896 1.6579C11.2738 0.773686 12.7107 0.773686 13.5949 1.6579L15.5843 3.64737L19.0107 0.221054L20.558 1.76842L17.1317 5.19474L19.2317 7.29474ZM7.62645 7.84737L5.85803 6.3L2.7633 9.50527C1.87909 10.3895 1.87909 11.8263 2.7633 12.7105L4.75277 14.7L0.221191 19.2316L1.76856 20.7789L6.30014 16.2474L8.28961 18.2368C9.17382 19.1211 10.6107 19.1211 11.4949 18.2368L14.7001 15.0316L13.1528 13.4842",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialItem);
export default __webpack_public_path__ + "static/media/credentialItem.71844d860d2c4f46f42bf11553438fd3.svg";
export { ForwardRef as ReactComponent };